export const IpayEwalletType = {
    TNG         : 1,
    BOOST       : 2,
    SHOPEEPAY   : 3,
    GRABPAY     : 4,
    MBBQR       : 5,
}


// const MID_TNG       = "2019082109112400000232"
// const MID_BOOST     = "online-Mobile88.com Sdn Bhd"
// const MID_SHOPEEPAY = "iPay88-Online"
// const MID_GRABPAY   = "d6abab93-748b-44b8-8661-f7b5f4cce543"
// const MID_MBBQR     = "QRPAY_IPAY88_CP"

export const ipayEwalletTypes = [
    {
        key     : IpayEwalletType.TNG,
        label   : "TNG",
        mid     : "2019082109112400000232",
        authCodePrefix  : null,
        merchantRate    : {
            base    : 0.0,
            rate    : 2.5,
        },
    },
    {
        key     : IpayEwalletType.BOOST,
        label   : "BWallet",
        mid     : "online-Mobile88.com Sdn Bhd",
        authCodePrefix  : null,
        merchantRate    : {
            base    : 0.0,
            rate    : 2.0,
        }
    },
    {
        key     : IpayEwalletType.SHOPEEPAY,
        label   : "ShopeePay",
        mid     : "iPay88-Online",
        authCodePrefix  : null,
        merchantRate    : {
            base    : 0.0,
            rate    : 2.5,
        }
    },
    {
        key     : IpayEwalletType.GRABPAY,
        label   : "GrabPay",
        mid     : "d6abab93-748b-44b8-8661-f7b5f4cce543",
        authCodePrefix  : null,
        merchantRate    : {
            base    : 0.0,
            rate    : 2.5,
        },
    },
    {
        key     : IpayEwalletType.MBBQR,
        label   : "MBBQR",
        mid     : "QRPAY_IPAY88_CP",
        authCodePrefix  : "MBBQR",
        merchantRate    : {
            base    : 0.0,
            rate    : 2.0,
        },
    },
]